import { GET_WAREHOUSE_LIST } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_WAREHOUSE_LIST: {
      return { ...state, ...{ list: action.warehousesData } };
    }
    default:
      return state;
  }
}
